import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      initial: 'P',
      gradient: 'from-hector-blue to-cyan-400',
      name: 'Prudence Millsap',
      title: 'Founder - Beauty By Earth',
      text: 'I really like Hector. The team is fantastic and incredibly responsive. Their AMC audiences and Dayparting drove 10.27% revenue growth, improved TACOS by 12.54%, and cut ad spend by 3.56%.'
    },
    {
      initial: 'D',
      gradient: 'from-hector-purple to-pink-400',
      name: 'David Dallaire',
      title: 'Founder - Dalstrong',
      text: 'With Hector, we restructured our campaigns, gained clear forecasting, and managed Prime Day with confidence. The platform gave us full control of ad spend heading into Q4.'
    },
    {
      initial: 'D',
      gradient: 'from-green-400 to-cyan-400',
      name: 'Doug Joyce',
      title: 'Founder - Brutus & Barnaby',
      text: 'With Hector, we improved TACOS by 40% and saved $10K every month in wasted ad spend. I\'d definitely recommend Hector to any brand focused on driving true incremental growth.'
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-hector-black mb-6">
            What Brands Say About <span className="bg-gradient-to-r from-hector-blue to-hector-purple bg-clip-text text-transparent">Hector</span>
          </h2>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card bg-gradient-to-br from-white to-hector-light-grey rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="flex items-center mb-6">
                <div className={`w-16 h-16 bg-gradient-to-br ${testimonial.gradient} rounded-full flex items-center justify-center text-white font-bold text-2xl mr-4`}>
                  {testimonial.initial}
                </div>
                <div>
                  <h4 className="font-bold text-hector-black">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.title}</p>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed mb-4">
                "{testimonial.text}"
              </p>
              <div className="flex text-yellow-400">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
              </div>
            </div>
          ))}
        </div>
        
        {/* CTA */}
        <div className="text-center mt-12 space-y-4">
 <a 
  href="https://hector.partnerstack.com/" 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block"
>
  <button
    className="cta-button px-6 py-4 rounded-xl font-semibold text-white text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 w-auto inline-block"
    style={{
      background: "linear-gradient(90deg, #CC2EF4 0%, #3E2EF4 100%)",
    }}
  >
    JOIN ACTIVE AFFILIATES
  </button>
</a>


          <p className="text-sm text-gray-600">
            Join active affiliates making 4-5 figures monthly. <span className="font-bold text-hector-black">No approval delays. No fine print.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
